module.exports = __webpack_public_path__ + "img/matchReport.2aac30d6.svg";